<template>
  <div
    class="header_component flex-eju-align"
    :class="[isLightStyle ? 'light_style' : '']"
  >
    <div class="header_left">
      <div class="header_left_top flex-eju-align">
        <div class="logo_word"><img v-if="isLightStyle" src="@/assets/svg/logo-white.svg" /><img v-else src="@/assets/svg/logo.svg" /></div>
        <div class="logo_tip"><img src="@/assets/svg/wechat-enterprise.svg" /></div>
      </div>
      <div class="header_left_bottom"> 克而瑞旗下数字化新营销解决方案</div>
    </div>
    <div class="header_center flex-eju-center header_center_menu">
      <div
        class="menu_item cursor"
        :class="[item.name === activeMenu.name ? 'active' : '']"
        v-for="(item, index) in menuList"
        :key="index"
        @click="goUrl(item)"
      >
        {{ item.name }}
        <div class="active_line"></div>
      </div>
    </div>
    <div class="header_right flex-eju">
      <!-- <div class="phone flex-eju-align">
        <img v-if="isLightStyle" class="phone_icon" src="@/assets/svg/call-white.svg" /><img v-else class="phone_icon" src="@/assets/svg/call.svg" /><span class="phone_num">400-8888-8888</span>
      </div> -->
      <div class="login_btn cursor" @click="showMask">
        登录/注册
        <div class="login_tip">免费体验</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLightStyle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuList: [
        {
          name: "首页",
        },
        // {
        //   name: "产品中心",
        //   url: 'http://www.cricbigdata.com'
        // },
        {
          name: "联系我们",
          url: ''
        },
      ],
      activeMenu: {
        name: "首页",
      },
    };
  },
  created() {},
  methods: {
    goUrl(item){
      if (item.url) {
        window.open(item.url)
      } else {
        this.$emit('goPageBottom');
      }
    },
    showMask() {
      this.$emit('showMask')
    }
  },
};
</script>

<style lang="less" scoped>
.header_component {
  width: 100%;
  min-width: 1366px;
  height: 80px;
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  padding: 0 80px;
  z-index: 10;
  background: #fff;
  box-shadow: 0px 0px 12px rgba(34, 34, 34, 0.1);
  transition: all .5s;
  justify-content: space-between;
  .logo_word {
    height: 24px;
  }
  .header_left_bottom {
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 3.5px;
    color: rgba(34, 34, 34, 0.8);
    margin-top: 2px;
  }
  .logo_tip {
    height: 24px;
    margin-left: 6px;
  }
  .header_center_menu {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .header_center {
    flex: 1;
    .menu_item {
      margin: 0 20px;
      font-size: 16px;
      line-height: 16px;
      color: #212538;
      position: relative;
      .active_line {
        display: none;
        position: absolute;
        left: 0;
        bottom: -8px;
        width: 100%;
        height: 2px;
        background: #007aff;
        border-radius: 4px;
      }
      &:hover {
        .active_line {
          display: block;
        }
      }
      &.active {
        font-weight: 700;
        .active_line {
          display: block;
        }
      }
    }
  }
  .phone_icon {
    font-size: 24px;
    margin-right: 4px;
  }
  .phone_num {
    color: #212538;
    font-size: 20px;
    line-height: 24px;
    font-weight: bold;
  }
  .login_btn {
    background: linear-gradient(105.88deg, #007aff 0%, #0057ff 100%);
    border-radius: 4px;
    border: 1px solid transparent;
    box-sizing: border-box;
    color: #fff;
    margin-left: 40px;
    font-size: 16px;
    height: 32px;
    padding: 0 12px;
    line-height: 32px;
    position: relative;
    box-shadow: 0 0 0 0px rgba(0,122,255,0.3);
    &:hover {
      animation: pulse 1.75s infinite cubic-bezier(0.66, 0, 0, 1);
    }
  }
  @keyframes pulse {
    to {
      box-shadow: 0 0 0 20px rgba(0,122,255,0);
    }
  }
  .login_tip {
    position: absolute;
    top: -10px;
    right: -46px;
    height: 24px;
    font-size: 12px;
    line-height: 24px;
    background: linear-gradient(90deg, #ffcaa4 0.15%, #ff6a6a 99.85%);
    border-radius: 4px 4px 4px 0px;
    color: #fff;
    padding: 0 4px;
  }
  &.light_style {
    background: rgba(255, 255, 255, 0.2);
    box-shadow: none;
    .header_left_bottom {
      color: #fff;
    }
    .header_center {
      .menu_item {
        color: #fff;
        .active_line {
          background: #fff;
        }
      }
    }
    .phone_icon {
      color: #fff;
    }
    .phone_num {
      color: #fff;
    }
    .login_btn {
      background: rgba(255, 255, 255, 0.05);
      border-color: #ffffff;
      box-shadow: 0 0 0 0px rgba(255,255,255,0.3);
      &:hover {
        animation: pulse1 1.75s infinite cubic-bezier(0.66, 0, 0, 1);
      }
    }
  }
}
@keyframes pulse1 {
  to {
    box-shadow: 0 0 0 20px rgba(255,255,255,0);
  }
}
</style>
